/* Medium Charlotte – WhatsApp-Knöpfe mit vorausgefülltem Angebot/Stichwort (M03)
   und Klick-Ereignis «whatsapp_anfrage» für die Messung (M04).
   Die Telefonnummer steht nicht im Quelltext: Links führen weiter über /whatsapp. */
(function () {
  var ANGEBOTE = {
    'kartenlegen-online-liebe-beruf-lebensweg-medium-charlotte': ['', ''],
    'meine-legungen': ['', ''],
    'dein-seelenbild': ['Dein Seelenbild', ''],
    'eine-konkrete-frage': ['1 konkrete Frage', ''],
    'tagesbotschaft': ['Tagesbotschaft', ''],
    'seelenwegweiser': ['Seelenwegweiser', ''],
    'drei-zusammenhaengende-fragen': ['Bis zu 3 zusammenhängende Fragen', ''],
    'pyramidenlegung': ['15-Karten-Pyramidenlegung', ''],
    'traumanalyse': ['Traumanalyse', ''],
    'grosse-klarheitslegung': ['Die Grosse Klarheitslegung', ''],
    'portaltag-sonderlegung': ['Portaltag Sonderlegung', ''],
    '90-tage-signature-analyse': ['90-Tage Signature-Analyse Premium', ''],
    'dualseelen-legung': ['Dualseelen-Legung', ''],
    'mond-legung': ['Mond-Legung', 'MOND'],
    'vom-ersten-treffen-zur-beziehung': ['Vom ersten Treffen zur Beziehung', 'TREFFEN'],
    'premium-berufslegung': ['Premium-Berufslegung', 'BERUF'],
    'die-seelenakte': ['Die Seelenakte', 'SEELENAKTE'],
    'mama-berufskompass': ['Mama-Berufskompass', 'MAMA'],
    'senioren-kompass': ['Senioren-Kompass', 'SENIOR'],
    'premium-legung-anziehung-rueckzug': ['Premium-Legung Anziehung, Rückzug & verborgene Gefühle', ''],
    'engelszahlen-legung': ['Engelszahlen-Legung', ''],
    'fuelle-legung': ['Fülle-Legung', ''],
    'premium-entscheidungs-kompass': ['Premium Entscheidungs-Kompass', 'KOMPASS'],
    'premium-beziehungs-realitaetscheck': ['Premium Beziehungs-Realitätscheck', 'REALITÄTSCHECK'],
    'premium-familien-klarheitskompass': ['Premium Familien-Klarheitskompass', 'FAMILIE'],
    'berufs-kraftkompass': ['Premium Berufs-Kraftkompass', 'KRAFT'],
    '12-monats-weg': ['Der 12-Monats-Weg', 'WEG'],
    'rundumblick': ['Premium-Rundumblick', 'RUNDUMBLICK'],
    'telefonberatung': ['Telefonberatung', ''],
    'seelen-code-exklusiv': ['Seelen-Code Exklusiv', ''],
    'monatsangebot': ['Monatsangebot: Kraftstück mit Orakellegung', 'MONATSANGEBOT'],
    'seelenverbindungs-botschaft': ['Seelenverbindungs-Botschaft', ''],
    'lichtwesen-botschaft-herz-und-weg': ['Grosse Lichtwesen-Botschaft Herz & Weg', ''],
    'premium-seelenbegleitung': ['Premium-Seelenbegleitung', ''],
    'botschaften-der-lichtwesen': ['Botschaften der Lichtwesen', ''],
    'rauhnaechte-begleiter': ['Rauhnächte-Begleiter 2026/27', '']
  };

  var path = location.pathname.replace(/\/+$/, '');
  var treffer = path.match(/^\/pages\/([^\/]+)$/);
  if (!treffer || !Object.prototype.hasOwnProperty.call(ANGEBOTE, treffer[1])) return;

  var angebot = ANGEBOTE[treffer[1]][0];
  var stichwort = ANGEBOTE[treffer[1]][1];
  var text = angebot
    ? 'Hallo Charlotte, ich interessiere mich für «' + angebot + '».'
    : 'Hallo Charlotte, ich habe eine Frage zu deinen Angeboten.';
  if (stichwort) text += ' Stichwort: ' + stichwort;

  function melden() {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('whatsapp_anfrage', {
          angebot: angebot || 'Allgemein',
          stichwort: stichwort || '',
          seite: path
        });
      }
    } catch (e) {}
  }

  function umstellen() {
    var links = document.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var ziel;
      try { ziel = new URL(link.getAttribute('href'), location.href); } catch (e) { continue; }
      if (ziel.host !== location.host) continue;
      if (ziel.pathname.replace(/\/+$/, '') !== '/whatsapp') continue;
      if (ziel.search.indexOf('text=') !== -1) continue;
      link.setAttribute('href', '/whatsapp?text=' + encodeURIComponent(text));
      link.addEventListener('click', melden);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', umstellen);
  } else {
    umstellen();
  }
})();
